<template>
  <div style="margin: 5px">
    <button class="btn btn-warning" @click="downloadFile(path)">Exportar en Pdf</button>
    <button class="btn btn-warning" @click="downloadResumen()">Descargar Resumen</button>
    <button
      type="button"
      style="visibility: hidden"
      id="openModal"
      class="btn btn-primary"
      data-toggle="modal"
      data-target="#exampleModal"
    ></button>

    <!-- Modal -->
    <div
      class="modal fade"
      id="exampleModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Globalwork Dice</h5>
          </div>
          <div class="modal-body" style="font-size: 25px; text-align: center">
            Generando Reporte
            <div class="pro-bar-container" style="margin-top: 8%">
              <div class="pro-bar pro-bar-width" data-pro-bar-percent="80">
                <div class="pro-bar-candy"></div>
              </div>
            </div>
          </div>
          <div class="modal-footer" style="visibility: hidden">
            <button
              type="button"
              class="btn btn-secondary"
              id="close"
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import jwt from "jsonwebtoken";
import axios from "axios";
export default {
  props: ["path", "jwt_secret", "secrect_key", "project", "project_type_name"],
  data() {
    return {};
  },
  methods: {
    downloadFile(url) {
      const project = JSON.parse(this.project);
      let fileName =
        project.first_name +
        project.last_name +
        " - " +
        this.project_type_name +
        " - " +
        project.person_id;
      console.log(fileName);
      document.getElementById("openModal").click();
      const token = jwt.sign(
        {
          secrect_key: this.secrect_key.length == 0 ? "GL0B4LW0RK" : this.secrect_key,
        },
        this.jwt_secret.length == 0 ? "GL0B4LW0RK2020REPORT" : this.jwt_secret
      );
      axios({
        url: url,
        method: "GET",
        responseType: "blob", // important
        headers: {
          token,
        },
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${fileName}.pdf`);
        document.body.appendChild(link);
        document.getElementById("openModal").click();
        link.click();
      });
    },
    downloadResumen() {
      const project = JSON.parse(this.project);
      let fileName =
        project.first_name +
        project.last_name +
        " - " +
        this.project_type_name +
        " - " +
        project.person_id;
      console.log(fileName);
      document.getElementById("openModal").click();
      const token = jwt.sign(
        {
          secrect_key: this.secrect_key.length == 0 ? "GL0B4LW0RK" : this.secrect_key,
        },
        this.jwt_secret.length == 0 ? "GL0B4LW0RK2020REPORT" : this.jwt_secret
      );
      axios({
        url: `https://reportes.globalwork.co/reports/resumen/${project.id}`,
        method: "GET",
        responseType: "blob", // important
        headers: {
          token,
        },
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${fileName}.pdf`);
        document.body.appendChild(link);
        document.getElementById("openModal").click();
        link.click();
      });
    },
  },
  created() {},
};
</script>

<style></style>
